import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateToProjectReports } from '../../../links/index.jsx';
import { selectProjectOwners } from '../../../../modules/projectOwners.js';

const mapStateToProps = (state) => ({
  owners: selectProjectOwners(state),
});

OwnersFilter.propTypes = {
  owners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      fullName: PropTypes.string.isRequired,
    })
  ),
  selectedOwnerIds: PropTypes.arrayOf(PropTypes.number),
};

OwnersFilter.defaultProps = {
  owners: [],
  selectedOwnerIds: [],
};

function OwnersFilter({ owners, selectedOwnerIds }) {
  const selectedCount = selectedOwnerIds.length;

  const handleSelect = useCallback(
    (ownerId) =>
      navigateToProjectReports({
        owners: ownerId ? xor(selectedOwnerIds, [ownerId]) : [],
      }),
    [selectedOwnerIds]
  );

  const renderMenuItem = useCallback(
    (owner) => (
      <React.Fragment key={owner.id}>
        <MenuItem
          active={selectedOwnerIds.includes(owner.id)}
          eventKey={owner.id}
          onSelect={handleSelect}
        >
          {owner.fullName}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedOwnerIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Owner</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="owners-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {owners.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(OwnersFilter);
